export const AdTypeEnum = {
  MMA: 'MultimediaAd',
  MSAN: 'AudienceAd',
  MSANV2: 'AudienceAdV2',
  Boost: 'Boost',
  NewBoost: 'NewBoost',
  pMax: 'pMax',
  LinkedIn: 'LinkedIn',
};
